
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';

export const PrivacyHeader = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <>
      <Helmet>
        <title>Privacy Policy - SocialScoop</title>
        <meta name="description" content="Privacy Policy for SocialScoop - Diminish the noise, amplify what matters" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Privacy Policy - SocialScoop" />
        <meta property="og:description" content="Privacy Policy for SocialScoop - Diminish the noise, amplify what matters" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://socialscoop.ai/privacy" />
        <meta property="og:site_name" content="SocialScoop" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Privacy Policy - SocialScoop" />
        <meta name="twitter:description" content="Privacy Policy for SocialScoop - Diminish the noise, amplify what matters" />
        <meta name="tiktok-developers-site-verification" content="TO70dKk5jUbO705wNncnyynFcNWHX2kK" />
        <meta name="verification-signature" content="TO70dKk5jUbO705wNncnyynFcNWHX2kK" />
        <meta name="document-type" content="privacy-policy" />
        <meta name="site-verification" content="TO70dKk5jUbO705wNncnyynFcNWHX2kK" />
        <link rel="canonical" href="https://socialscoop.ai/privacy" />
      </Helmet>
      
      {/* Verification signatures for TikTok */}
      <div style={{ display: 'none' }}>
        <span id="tiktok-developers-site-verification">TO70dKk5jUbO705wNncnyynFcNWHX2kK</span>
        <span className="verification-signature">TO70dKk5jUbO705wNncnyynFcNWHX2kK</span>
        <span data-verify="tiktok">TO70dKk5jUbO705wNncnyynFcNWHX2kK</span>
      </div>
      
      <div className="text-center mb-8">
        <button 
          onClick={handleLogoClick}
          className="inline-flex items-center space-x-2 mb-4 hover:opacity-80 transition-opacity cursor-pointer"
        >
          <div className="w-8 h-8 bg-gradient-to-br from-green-600 to-emerald-700 rounded-sm rotate-45 flex items-center justify-center">
            <span className="text-white font-bold text-sm rotate-[-45deg]">S</span>
          </div>
          <span className="text-2xl font-bold text-green-600 tracking-tight hover:text-green-700 transition-colors">SocialScoop.ai</span>
        </button>
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
        <p className="text-gray-600">Last updated: {new Date().toLocaleDateString()}</p>
        <div className="hidden" id="verification-signature">TO70dKk5jUbO705wNncnyynFcNWHX2kK</div>
        <div style={{ visibility: 'hidden', height: 0, overflow: 'hidden' }}>
          tiktok-developers-site-verification=TO70dKk5jUbO705wNncnyynFcNWHX2kK
        </div>
      </div>
    </>
  );
};
